import PropTypes from "prop-types";
import React, { useState } from "react";
import Storage from "../../../utils/storage";
import Button from "../../Button/Button";
import { useHistory } from "react-router-dom";
import CalendarIcon from "../../../assets/assets/calendar_today-24px.svg";

const TestApproval = (props) => {
  const { runTestStatus, testApproval, applicationId } = props;
  const history = useHistory();

  let userStatus = Storage.get("user-access-data");
  const user = JSON.parse(userStatus);
  let userType = user && user.type;

  const [showAlert, setShowAlert] = useState(true);

  const goToMigration = () => {
    history.push({
      pathname: "/nip/integration/migration",
      state: {
        id: applicationId,
      },
    });
  };

  return (
    <div>
      {runTestStatus && !testApproval && (
        <div className="nip-public-keys-alert1">
          <div className="text1">
            Your application is pending, please check back later to continue
            integration. Thank you.
          </div>
          <div
            className="close1"
            data-testid="close1"
            onClick={() => setShowAlert(false)}
          >
            X
          </div>
        </div>
      )}

      {runTestStatus && testApproval && (
        <div className="doc-upload">
          {showAlert && (
            <div className="nip-public-keys-alert3">
              <div className="text3">
                The integration and testing of NIP API has been completed
                successfully.
              </div>
              <div
                className="close3"
                data-testid="close3"
                onClick={() => setShowAlert(false)}
              >
                X
              </div>
            </div>
          )}

          <div className="doc-pending">
            <div className="middle-box">
              <br />
              <span className="middle-box-subtitle">One Last Step</span>
              <div className="middle-box-image">
                <img src={CalendarIcon} alt="calendar icon" />
              </div>
              <div className="middle-box-title">Schedule Migration</div>
              <span className="middle-box-subtitle">
                As part of your application, you need to select a <br />{" "}
                migration date and time
              </span>

              <Button
                className="button"
                type="submit"
                width="150px"
                height="50px"
                text="PROCEED"
                testId="goToMigrationPage"
                disabled={userType !== "company"}
                onClick={() => goToMigration()}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

TestApproval.propTypes = {
  applicationId: PropTypes.any,
  runTestStatus: PropTypes.any,
  testApproval: PropTypes.any,
};

export default TestApproval;
